/**
 * Optimized FontAwesome icon configuration
 * Only imports the icons actually used in the package
 */

import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Regular icons
import {
  faGripDotsVertical,
  faFolderCheck,
  faBooks,
  faShareFromSquare,
  faTrashCan,
  faPen,
  faArrowUp,
  faArrowDown,
} from '@fortawesome/pro-regular-svg-icons';

// Solid icons
import {
  faArrowDownArrowUp as faArrowDownArrowUpSolid,
  faXmark as faXmarkSolid,
  faCheck as faCheckSolid,
} from '@fortawesome/pro-solid-svg-icons';

// Thin icons
import { faPhotoFilm as faPhotoFilm } from '@fortawesome/pro-thin-svg-icons';

// Light icons
import { faPlus as faPlusLight } from '@fortawesome/pro-light-svg-icons';

// Create arrays and spread them to avoid TypeScript issues
const regularIcons: IconDefinition[] = [
  faGripDotsVertical,
  faFolderCheck,
  faBooks,
  faShareFromSquare,
  faTrashCan,
  faPen,
  faArrowUp,
  faArrowDown,
];

const solidIcons: IconDefinition[] = [faArrowDownArrowUpSolid, faXmarkSolid, faCheckSolid];

const thinIcons: IconDefinition[] = [faPhotoFilm];

const lightIcons: IconDefinition[] = [faPlusLight];

// Add all icon arrays to the library
library.add(...regularIcons);
library.add(...solidIcons);
library.add(...thinIcons);
library.add(...lightIcons);
